import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import Link from "@openstack_dev/gatsby-theme-marketing-oif-core/src/components/Link";
import "@fortawesome/fontawesome-free/css/all.css";

import { Stack } from "@mui/material";
import styles from "./index.module.scss";

const SoftwareNavBar = ({ links }) => {
  const [pathname, setPathname] = useState(window?.location?.pathname);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  const tab = useMemo(
    () =>
      links.findIndex(
        ({ url, subLinks }) =>
          url === pathname || subLinks?.some((sub) => sub.url === pathname)
      ),
    [links, pathname]
  );

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    if (!(window?.location?.pathname ?? null)) return;

    setPathname(window.location.pathname);
  }, [window?.location?.pathname]);

  useEffect(() => {
    if (!isMobileMenuOpen) return () => {};

    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsMobileMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      <nav className={styles.container}>
        <div className={styles.softwareTabWrapper}>
          <ul className={styles.listWrapper}>
            {links.map((link, index) => {
              const isSubLink = !!link.subLinks?.some(
                (sub) => sub.url === pathname
              );
              const isCurrent = pathname === link?.url;
              const isSelected = tab === index || isSubLink || isCurrent;
              return (
                <li key={`nav-software-${link.title}`}>
                  <Link
                    to={link?.url}
                    activeClassName={styles.active}
                    target="_self"
                    className={isSelected ? styles.active : ""}
                  >
                    {link?.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={styles.softwareTabDropdown}>
          <div ref={dropdownRef}>
            <button
              onClick={() => handleMobileMenuToggle()}
              aria-expanded="false"
              aria-haspopup="true"
              data-toggle="dropdown"
              type="button"
              className={styles.dropdownToggle}
            >
              Select a Page &nbsp;
              <i className="fa fa-caret-down" />
            </button>
            {isMobileMenuOpen && (
              <ul className={styles.dropdownMenu}>
                {links.map((link, index) => {
                  const isSubLink = !!link.subLinks?.some(
                    (sub) => sub.url === pathname
                  );
                  const isCurrent = pathname === link?.url;
                  const isSelected = tab === index || isSubLink || isCurrent;

                  return (
                    <li key={`nav-software-${link.title}`}>
                      <Link
                        to={link?.url}
                        activeClassName={styles.active}
                        target="_self"
                        className={isSelected ? styles.active : ""}
                      >
                        {link?.title}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        </div>
      </nav>
      <Stack direction="column" alignItems="center" className={styles.subNav}>
        <Stack
          direction="row"
          flexWrap="nowrap"
          className={styles.subNavContainer}
        >
          {links[tab]?.subLinks?.map((link) => (
            <div key={`sub-nav-software-${link.title}`}>
              <Link
                to={link?.url}
                target="_self"
                activeClassName={styles.activeSubLink}
                className={pathname === link?.url ? styles.activeSubLink : ""}
              >
                {link?.title}
              </Link>
            </div>
          ))}
        </Stack>
      </Stack>
    </>
  );
};

SoftwareNavBar.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      subLinks: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired
        })
      )
    })
  ).isRequired
};

export default SoftwareNavBar;
